import React, { useState } from 'react';
import { Card, Col, Row } from 'reactstrap';
import { formatPrice } from '../components/capitalizeFunction';
import LoadingSpiner from '../components/LoadingSpiner';
import { useRapportRange } from '../../Api/queriesRapport';

/**
 * Rapport par plage de dates — optimisation :
 * avant : trois useAll* + filtres isBetweenDates côté client.
 * maintenant : GET /api/rapport/range (sans dates = tout l’historique, comme avant).
 */
const RapportBySemaine = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const { data: rapport, isLoading, error } = useRapportRange(
    startDate,
    endDate
  );

  const totalCommandeNumber = rapport?.commandeCount ?? 0;
  const totalCommandeAmount = rapport?.totalCommandeAmount ?? 0;
  const totalPaiementsPaye = rapport?.totalPaiementsPaye ?? 0;
  const totalPaiementsToPaye = rapport?.totalPaiementsToPayeAmount ?? 0;
  const totalDepenses = rapport?.totalDepenses ?? 0;
  const totalAchat = rapport?.totalAchat ?? 0;
  const benefice = rapport?.benefice ?? 0;

  return (
    <React.Fragment>
      <Card style={{ boxShadow: '0px 0px 10px rgba(123, 123, 123, 0.28)' }}>
        {/* Filtrage Bouton */}
        <Row className='mb-4'>
          <Col md={12}>
            <h4 className='text-center my-4' style={{ color: '#27548A' }}>
              Veuillez Sélectionnez
            </h4>
          </Col>
          <div className='mb-4 d-flex justify-content-around align-items-center'>
            <Col
              sm={4}
              style={{
                background: 'rgb(72, 60, 60)',
                padding: '15px ',
                borderRadius: '15px',
              }}
            >
              <p className='text-center text-light'>Date de Début</p>
              <input
                type='date'
                max={new Date().toISOString().split('T')[0]}
                className='form-control border-1 border-dark'
                value={startDate || ''}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>
            <Col
              sm={4}
              style={{
                background: 'rgb(72, 60, 60)',
                padding: '15px ',
                borderRadius: '15px',
              }}
            >
              <p className='text-center text-light'>Date de Fin</p>
              <input
                type='date'
                min={startDate}
                max={new Date().toISOString().split('T')[0]}
                className='form-control border-1 border-dark'
                value={endDate || ''}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>
          </div>
        </Row>

        {error && (
          <div className='text-danger text-center px-3'>
            Erreur de chargement du rapport
          </div>
        )}
        {isLoading && <LoadingSpiner />}

        {/* Résultats */}
        <Row>
          {/* Bénefices */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: 'linear-gradient(to top right , #090979, #222831)',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              {' '}
              <h5 className='mb-1 text-white'>Bénéfice</h5>
              {benefice <= 0 ? (
                <h4 className='text-danger'>{formatPrice(benefice)} F</h4>
              ) : (
                <h4 className='text-success'>{formatPrice(benefice)} F</h4>
              )}
            </Card>{' '}
          </Col>
          {/* Paiements */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: 'linear-gradient(to top right , #090979, #222831)',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <h4 className='mb-1' style={{ color: '#B6F500' }}>
                {formatPrice(totalPaiementsPaye)} F
              </h4>
              <p className='text-white'>
                Revenue (Chiffre d'Affaire)
                <i
                  className='fas fa-level-down-alt ms-2 fs-4'
                  style={{ color: '#B6F500' }}
                ></i>
              </p>
            </Card>{' '}
          </Col>
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: 'linear-gradient(to top right , #090979, #222831)',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <h4 className='mb-1' style={{ color: '#B6F500' }}>
                {formatPrice(totalAchat)} F
              </h4>
              <p className='text-white'>
                Achat sur Revenue
                <i
                  className='fas fa-level-down-alt ms-2 fs-4'
                  style={{ color: '#B6F500' }}
                ></i>
              </p>
            </Card>{' '}
          </Col>

          {/* Dépences */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: 'linear-gradient(to top right , #090979, #222831)',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              {' '}
              <h4 className='mb-1' style={{ color: '#CB0404' }}>
                {formatPrice(totalDepenses)} F
              </h4>
              <p className='text-white'>
                Dépenses
                <i
                  className='fas fa-level-up-alt ms-2 fs-4'
                  style={{ color: '#CB0404' }}
                ></i>
              </p>
            </Card>{' '}
          </Col>

          {/* Commande */}
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: 'linear-gradient(to top right , #090979, #222831)',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <h5 className='text-warning mb-1'>{totalCommandeNumber}</h5>
              <p className='text-white'>Commandes</p>
            </Card>{' '}
          </Col>
          <Col sm={6} lg={4}>
            <Card
              style={{
                background: 'linear-gradient(to top right , #090979, #222831)',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100px',
              }}
            >
              <h5 className='my-1 text-light'>
                Total À Payé:{' '}
                <span className='text-light ps-2'>
                  {' '}
                  {formatPrice(totalCommandeAmount)} F
                </span>
              </h5>
              <h5 className='my-1 text-light'>
                Net Payé:{' '}
                <span className='text-success ps-2'>
                  {' '}
                  {formatPrice(totalPaiementsPaye)} F
                </span>
              </h5>
              <h5 className='my-1 text-light'>
                Impayé:{' '}
                <span className='text-danger ps-2'>
                  {' '}
                  {formatPrice(totalPaiementsToPaye)} F
                </span>
              </h5>
            </Card>{' '}
          </Col>
        </Row>
      </Card>
    </React.Fragment>
  );
};

export default RapportBySemaine;
